export const lyric10 = `I'm certainly sitting on your last good try
Here I am again with half a goodbye
Wonder if you're really gone this time
Just when I'm about to lose my mind
There you are again on my phone
The moon is rising and you're all alone
Maybe we could just hang a while
Maybe we can make each other smile
Oh no, here I go
Why don't you go ahead and break my heart?
Why are you waiting, is it way too hard?
If moving on is what you wanna do
Why don't you do it?
Why don't you do it, baby?
You can't tell me that we'll still be friends
And maybe someday we can try again
If you really need a brand new start
Why don't you go ahead and break my heart?
I never ever meant to get so into you
Thought I was using you just to get me through
You know I'm broken, I don't trust anyone
Last thing I needed was to fall in love
You've got me dreaming, got me thinking, I've got some hope
There is nobody else I wanna get to know
But I'm so scared, I don't know what to do
How did you get me so into you?
Oh no, and here I go
Why don't you go ahead and break my heart?
Why are you waiting, is it way too hard?
If moving on is what you wanna do
Why don't you do it?
Why don't you do it, baby?
You can't tell me that we'll still be friends
And maybe someday we can try again
If you really need a brand new start
Why don't you go ahead and break my heart?
There's your reasons
There's your cards
What are you waiting for?
The one to break my heart
Yeah, you can't tell me that we'll still be friends
And maybe someday we can try again
If you really need a brand new start
Why don't you go ahead and break my heart?
Oh, go on and break, go on and break my heart
Go on and break, go on and break my heart`